/**
 * Created by 11789 on 2017/5/24.
 * @discription  WEB直播间的通行证
 * @parameter
 * @example
 */

import cookie from './cookie';

export default {
	isLogin: function() { //TODO 校验是否已经登录
		if(cookie.get('uid') && cookie.get('accessToken') && cookie.get('openid')) {
			return true;
		} else {
			return false;
		}
	},
	loginout: function() { // 用户登出
		$.publish(config.Event_Type.loginOut); // 广播出去
	},
	loginJump: function() {
		var roomid = 0;
		window.location = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100717093&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3fjumpUrl%3dhttp%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fweblivelogin%26roomid%3d' + roomid + '%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info';
	},
	getUserInfo: {
		accessToken: cookie.get("accessToken"),
		isNew: cookie.get("isNew"),
		lgtime: cookie.get("lgtime"),
		mcheck: cookie.get("mcheck"),
		nick: decodeURIComponent(cookie.get("nick")),
		openid: cookie.get("openid"),
		refreshToken: cookie.get("refreshToken"),
		uid: cookie.get("uid"),
		webToken: cookie.get("webToken")
	}
}


// WEBPACK FOOTER //
// ./src/libs/passport.js